// @flow

// DataTable Module
import datatable from './datatable'

// Operator State
import { initialState as operatorState } from 'fc-operator-sampling-jobs'

// Constants
import {
  TABLE_BRANCH,
} from './constants'

export default {
  [TABLE_BRANCH]: datatable.initialState,
  ...operatorState,
}
